/**
 * Created by vladislav on 31/10/2022
 */

const CustomerView = function (customer, unitView) {
    this.unitView = unitView;
    this.customer = customer;

    this.restoreState();
};

CustomerView.prototype.animateStateChange = function () {
    let animation = undefined;
    let effect = undefined;

    switch (this.customer.getState()) {
        case Customer.STATE_COOKING:
            animation = "start_order";
            effect = "merge.customer.start_order";
            break;
        case Customer.STATE_READY:
            animation = "ready";
            effect = "merge.customer.order_ready";
            break;
    }

    if (animation) {
        this.inAnimation = true;
        this.customer.unit.hideAdditionalViews();
        this.setChangeStateAnimation(animation, effect, () => {
            this.inAnimation = false;
            this.customer.unit.showAdditionalViews();
            this.restoreState();
        });
    } else {
        this.inAnimation = false;
        this.restoreState(true);
    }
};

CustomerView.prototype.restoreState = function (animated) {
    if (this.inAnimation) {
        return;
    }

    const type = this.chooseAdditionalView();
    if (type) {
        this.createAdditionalView(type, animated);
    } else {
        this.removeAdditionalViews(animated);
    }

    if (this.unitView.getAnimation()) {
        this.setMainAnimationSpine();
    }

    this.customer.updateAdditionalViewVisibility();
};

CustomerView.prototype.setChangeStateAnimation = function (animation, effect, callback) {
    const sprite = this.unitView.sprite;

    if (sprite instanceof cleverapps.Spine || (sprite instanceof LazyAsset && sprite.isLoaded() && sprite.isSpine())) {
        if (sprite.hasAnimation(animation)) {
            this.mainAnimation = animation;
            sprite.setAnimation(0, animation, false);
            cleverapps.effects.fire(effect);
            sprite.setCompleteListenerOnce(callback);
            return;
        }
    }

    callback();
};

CustomerView.prototype.setMainAnimationSpine = function () {
    let mainAnimation = undefined;

    if (this.customer.getState() === Customer.STATE_COOKING) {
        mainAnimation = this.unitView.sprite.hasAnimation("building_animation") ? "building_animation" : "busy";
    }

    if (this.mainAnimation !== mainAnimation) {
        this.mainAnimation = mainAnimation;
        UnitView.applyDefaultAnimation(this.unitView.sprite, this.customer.unit, mainAnimation);
    }
};

CustomerView.prototype.chooseAdditionalView = function () {
    if (this.customer.getCookingRecipe() && this.customer.getCookingTimeLeft()) {
        if (this.customer.getViewType() === Customer.VIEW.ORDERS_WINDOW) {
            return "waiting";
        } 
        return "timer";
    } if (!cleverapps.config.demoMode && this.customer.getCurrentRecipe()) {
        const hungryGamesCustomer = typeof HungryGamesCustomer !== "undefined" && this.customer.unit.findComponent(HungryGamesCustomer);
        if (hungryGamesCustomer && hungryGamesCustomer.completing) {
            return undefined;
        }

        if (this.customer.getViewType() === Customer.VIEW.EXTENDED_CUSTOMER_VIEW) {
            const recipe = this.customer.getCurrentRecipe();
            if (!hungryGamesCustomer && recipe.getOrder().length === 0 && this.customer.isEnoughIngredientsForRecipe()) {
                return "fix_view";
            }

            if (Map2d.currentMap.customers.isCustomerSelected(this.customer)) {
                return "extended_ingredients";
            }
        }

        if (this.customer.getViewType() === Customer.VIEW.ORDERS_WINDOW) {
            if (this.customer.canCook()) {
                return "exclamation";
            }
            return "exclamation_off";
        }

        return "ingredients";
    }
};

CustomerView.prototype.createAdditionalView = function (type, animated) {
    if (this.unitView.getAdditionalView(type)) {
        return;
    }

    const prevView = this.unitView.getAdditionalView("ingredients") || this.unitView.getAdditionalView("extended_ingredients");
    const initialSize = prevView && prevView.view ? prevView.view.getContentSize() : undefined;

    this.removeAdditionalViews();

    let infoView;

    switch (type) {
        case "exclamation":
            infoView = this.createPrizeView({ sprite: bundles.merge.frames.prize_exclamation });
            break;
        case "exclamation_off":
            infoView = this.createPrizeView({ sprite: bundles.merge.frames.prize_exclamation_off });
            break;
        case "waiting":
            infoView = this.createPrizeView({ waiting: true });
            break;
        case "ingredients":
            infoView = this.createIngredientsView();
            break;
        case "extended_ingredients":
            infoView = this.createExtendedIngredientsView();
            break;
        case "fix_view":
            infoView = this.createFixView();
            break;
        case "timer":
            infoView = this.createTimer();
            break;
    }

    this.unitView.createAdditionalView(type, infoView);

    if (animated && !this.customer.unit.additionalViewsHidden) {
        const additionalView = this.unitView.getAdditionalView(type);
        additionalView.animateAppear(initialSize);
    }
};

CustomerView.prototype.removeAdditionalViews = function (animated) {
    this.unitView.removeAdditionalView("exclamation", !animated);
    this.unitView.removeAdditionalView("exclamation_off", !animated);
    this.unitView.removeAdditionalView("ingredients", !animated);
    this.unitView.removeAdditionalView("extended_ingredients", !animated);
    this.unitView.removeAdditionalView("fix_view", !animated);
    this.unitView.removeAdditionalView("timer", !animated);
    this.unitView.removeAdditionalView("waiting", !animated);

    delete this.button;
};

CustomerView.prototype.createIngredientsView = function () {
    const recipe = this.customer.getCurrentRecipe();

    const infoView = new CustomerInfoView({ recipe, customer: this.customer });
    infoView.setAlignment(this.unitView.width / 2, this.unitView.height + cleverapps.styles.InfoView.dy);
    infoView.setAnchorPoint(0.5, 0);

    cleverapps.UI.onClick(infoView, this.unitView.handleClick.bind(this.unitView));

    return infoView;
};

CustomerView.prototype.createExtendedIngredientsView = function () {
    const recipe = this.customer.getCurrentRecipe();

    const infoView = new ExtendedCustomerView({ recipe, customer: this.customer });
    infoView.setAlignment(this.unitView.width / 2, this.unitView.height + cleverapps.styles.InfoView.dy);
    infoView.setAnchorPoint(0.5, 0);

    cleverapps.UI.onClick(infoView, this.unitView.handleClick.bind(this.unitView));

    return infoView;
};

CustomerView.prototype.createFixView = function () {
    const infoView = new FixCustomerView(this.customer);
    infoView.setAlignment(this.unitView.width / 2, this.unitView.height + cleverapps.styles.InfoView.dy);
    infoView.setAnchorPoint(0.5, 0);

    cleverapps.UI.onClick(infoView, this.unitView.handleClick.bind(this.unitView));

    return infoView;
};

CustomerView.prototype.createPrizeView = function (options) {
    const prizeView = new PrizeView(options, {
        onClick: this.customer.unit.handleClick.bind(this.customer.unit),
        unit: this.customer.unit
    });
    prizeView.setAlignment(this.unitView.width / 2, this.unitView.height);

    return prizeView;
};

CustomerView.prototype.createTimer = function () {
    const styles = cleverapps.styles.CustomerView;

    const cookingRecipe = this.customer.getCookingRecipe();
    const cookingTimeLeft = this.customer.getCookingTimeLeft();

    const countdown = new cleverapps.CountDown(cookingTimeLeft, {
        onTick: this.updateBtn.bind(this)
    });

    const timer = new cleverapps.CountDownView(countdown, {
        font: cleverapps.styles.FONTS.COMPONENT_TIMER_TEXT,
        icon: bundles.small_timer_merge.frames.timer_png,
        bar: {
            type: ScaledProgressBar.Types.blue,
            width: styles.timer.width,
            fullValue: cookingRecipe.getCookingDuration(),
            reversed: false
        }
    });
    timer.setAlignment(styles.timer);

    if (this.customer.getViewType() !== Customer.VIEW.ORDERS_WINDOW) {
        const button = this.button = new cleverapps.UI.Button({
            width: styles.button.width,
            height: styles.button.height,
            text: `$$${Unit.CalcSpeedUPPrice(cookingTimeLeft)}>>`,
            type: cleverapps.styles.UI.Button.Images.small_button_blue,
            onClicked: this.speedUp.bind(this)
        });
        this.updateBtn(cookingTimeLeft);
        button.setAlignment(styles.button);
        timer.addChild(button);
    }

    return timer;
};

CustomerView.prototype.speedUp = function () {
    if (this.button) {
        const price = Unit.CalcSpeedUPPrice(this.customer.getCookingTimeLeft());
        if (cleverapps.user.spendHard(cleverapps.EVENTS.SPENT.CUSTOMER, price)) {
            this.customer.enjoy();
        }
    }
};

CustomerView.prototype.updateBtn = function (timeLeft) {
    if (this.button) {
        timeLeft = timeLeft !== undefined ? timeLeft : this.customer.getCooldownTimeLeft();
        const price = Unit.CalcSpeedUPPrice(timeLeft);
        if (this.button.speedPrice !== price) {
            this.button.speedPrice = price;
            this.button.setString((price ? (`$$${price}`) : Messages.get("UseGoldButton.free")) + TextWithIcon.ICONS_BY_NAME.speedup);
        }
    }
};

CustomerView.prototype.collectUnitAnimation = function (unit, callback) {
    const collectible = unit.findComponent(Collectible);
    if (collectible) {
        collectible.onFeed(this.unitView, callback);
    } else {
        const unitView = unit.onGetView();
        if (unitView) {
            this.collectAction = unitView.runAction(new cc.Sequence(
                StandartAnimations.animateCollect(unitView, this.unitView, { scale: 0.6 }),
                new cc.RemoveSelf()
            )).setFinalize(callback);
        } else {
            callback();
        }
    }
};

CustomerView.prototype.clearAnimations = function () {
    if (this.collectAction && !this.collectAction.isDone()) {
        this.unitView.stopAction(this.collectAction);
        delete this.collectAction;
    }
};

cleverapps.styles.CustomerView = {
    distance: 600,

    button: {
        height: 50,
        width: 130,
        x: { align: "center" },
        y: { align: "bottom", dy: -52 }
    },

    timer: {
        x: { align: "center" },
        y: { align: "bottom", dy: 40 },
        width: 140
    }
};